import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import SpcificPageModal from '../../Modals/SpcificPageModal';
import { apiData } from '../../../actions';
import DataLoader from '../../../Utils/DataLoader';
import ThingsToDoBanner from './ThingsToDoBanner';
import LocalMusicFilter from './LocalMusic/LocalMusicFilter';
import MusicSlide from './LocalMusic/MusicSlide';
import MusicFilterDataSlider from './LocalMusic/MusicFilterDataSlider';
import ViewAllDealsModal from './LocalMusic/ViewAllDealsModal';


export default function MusicThings({ category }) {
  const MAX_LIMIT = 50;
  const INITIAL_LIMIT = 12;
  const place = useSelector(state => state.place);
  const topRef = useRef(null);
  const filterResultRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [checkedFilters, setCheckedFilters] = useState({});
  const [specificModal, setSpecificModal] = useState(false);
  const [sliderData, setSliderData] = useState([]);
  const [grpGliderData, setGrpSliderData] = useState(null);
  const [dynamicSliderData, setDynamicSliderData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [limit, setLimit] = useState(12);
  const [viewAllModal, setViewAllModal] = useState(false);
  const [activeModalSource, setActiveModalSource] = useState(null);



  const keywordFromRoute = category
    ? decodeURIComponent(category).toLowerCase()
    : ""; // fallback

  const hasActiveFilter =
    searchValue.trim() !== "" || Object.keys(checkedFilters).length > 0;

  const handleReset = () => {
    setSearchValue("");
    setCheckedFilters({});
    setDynamicSliderData([]);
    setSliderData([]);
    setGrpSliderData([]);
  };


  const fetchDeals = async (currentLimit = 12) => {
    try {
      setLoader(true);

      const res = await apiData.getYelpDeals({
        city: place,
        keyword: keywordFromRoute,
        limit: currentLimit,
      });

      setSliderData(res);
      setDynamicSliderData([]);
    } catch (err) {
      console.error(err);
      setSliderData([]);
    } finally {
      setLoader(false);
    }
  };
  const grpFetchDeals = async (currentLimit = 12) => {
    try {
      setLoader(true);

      const res = await apiData.getGroupon({
        city: place,
        keyword: keywordFromRoute,
        limit: currentLimit,
      });

      setGrpSliderData(res);
      setDynamicSliderData([]);
    } catch (err) {
      console.error(err);
      setGrpSliderData([]);
    } finally {
      setLoader(false);
    }
  };

  const fetchFilteredDeals = async (currentLimit = 12, append = false) => {
    try {
      setLoader(true);

      const activeFilters = Object.keys(checkedFilters);
      const keyword =
        searchValue.trim() || activeFilters.join(",");

      const payload = {
        city: place,
        keyword,
        limit: currentLimit,
      };

      const res = await apiData.localMusicDealsFilterSearch(payload);
      const events = res?._embedded?.events || [];

      setDynamicSliderData(prev =>
        append ? [...prev, ...events] : events
      );

    } catch (err) {
      console.error(err);
      setDynamicSliderData([]);
    } finally {
      setLoader(false);
    }
  };


  const handleCloseViewAllModal = () => {
    setViewAllModal(false);
    setLimit(INITIAL_LIMIT);

    // Optional: reload first page data
    fetchDeals(INITIAL_LIMIT);
    grpFetchDeals(INITIAL_LIMIT);
  };





  const fetchBothDeals = async () => {
    try {
      setLoader(true);
      await Promise.all([
        fetchDeals(),
        grpFetchDeals()
      ]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const hasFilter =
      searchValue.trim() !== "" ||
      Object.keys(checkedFilters).length > 0;

    if (hasFilter) {
      setLimit(12);
      fetchFilteredDeals(12, false);
    } else {
      fetchBothDeals();
    }
  }, [place, category, searchValue, checkedFilters]);


  const handleLoadMore = () => {
    const newLimit = limit + 12;
    setLimit(newLimit);
    fetchFilteredDeals(newLimit, true);
  };
  const handleLoadMoreForYelp = () => {
    setLimit(prev => {
      if (prev >= MAX_LIMIT) return prev; // 🚫 stop

      const newLimit = Math.min(prev + 12, MAX_LIMIT);
      fetchDeals(newLimit);
      return newLimit;
    });
  };


  const handleLoadMoreForGrp = () => {
    setLimit(prev => {
      if (prev >= MAX_LIMIT) return prev; // 🚫 stop

      const newLimit = Math.min(prev + 12, MAX_LIMIT);
      grpFetchDeals(newLimit);
      return newLimit;
    });
  };





  const handleViewAll = (source) => {
    setActiveModalSource(source); // "yelp" or "groupon"
    setViewAllModal(true);
  };




  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenSpecficPopup");

    if (!hasSeenPopup) {

      setSpecificModal(true);
      localStorage.setItem("hasSeenSpecficPopup", "true");
    }

    if (place && !hasSeenPopup) {
      setSpecificModal(true);
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        localStorage.setItem("lastSeen", Date.now());
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [place]);

  useEffect(() => {
    if (
      Object.keys(checkedFilters).length > 0 &&
      dynamicSliderData.length > 0 &&
      filterResultRef.current
    ) {
      filterResultRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [dynamicSliderData.length, checkedFilters]);


  useEffect(() => {
    if (Object.keys(checkedFilters).length === 0 && topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [checkedFilters]);


  return (
    <>
      <div ref={topRef}>
        <ThingsToDoBanner />
      </div>
      <section className="section-equal-padding top-spacing170 top-spacing-120">
        <div className="container-fluid">
          <div className='row'>
            <LocalMusicFilter
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              checkedFilters={checkedFilters}
              setCheckedFilters={setCheckedFilters}
              onReset={handleReset} />
            <div className="col-sm-12 col-md-8 col-xxl-9">
              {loader && (
                <div className="d-flex justify-content-center align-items-center py-5">
                  <DataLoader />
                </div>
              )}

              {!loader && (sliderData || grpGliderData) && (
                <MusicSlide sliderData={sliderData} grpGliderData={grpGliderData} onViewAll={handleViewAll} />
              )}

              {!loader && hasActiveFilter && (
                <div ref={filterResultRef}>
                  <MusicFilterDataSlider
                    sliderData={dynamicSliderData}
                    checkedFilters={checkedFilters}
                    isLoading={loader}
                    onLoadMore={handleLoadMore}
                  />
                </div>
              )}
            </div>
          </div>

        </div>
      </section>

      {specificModal && (
        <SpcificPageModal
          specificModal={specificModal}
          setSpecificModal={setSpecificModal}
        />
      )}

      {
        <ViewAllDealsModal
          show={viewAllModal}
          onHide={handleCloseViewAllModal}
          sliderData={sliderData}
          grpGliderData={grpGliderData}
          isLoading={loader}
          onLoadMoreForYelp={handleLoadMoreForYelp}
          onLoadMoreForGrp={handleLoadMoreForGrp}
          activeSource={activeModalSource}
        />
      }
    </>
  )
}
